'use client';
import React from 'react';
import styles from './SearchInput.module.scss';
export const SearchInput = ({ handleSearch, value, id, label }) => {
    return (<div className={styles.searchWrapper}>
      {label ? <label htmlFor={id}>{label}</label> : null}
      <div className={styles.searchInputContainer}>
        <input id={id} type='search' value={value} onChange={(event) => {
            handleSearch(event.target.value);
        }} className={styles.searchInput}/>
        <svg className={styles.searchIcon} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <g clipPath='url(#clip0_630_3938)'>
            <path d='M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z' stroke='#0076B8' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
            <path d='M21 21L17 17' stroke='#0076B8' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
          </g>
          <defs>
            <clipPath id='clip0_630_3938'>
              <rect width='24' height='24' fill='white'/>
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>);
};
